import type { ReactNode } from "react"
import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    message: {
        borderRadius: ".5rem",
        padding: ".75rem 1rem",
        fontWeight: "500",
        marginBottom: ".5rem",
    },
    messageInfo: {
        color: theme.palette.tailwind.blue[950],
        background: theme.palette.tailwind.sky[100],
    },
    messageWarning: {
        color: theme.palette.tailwind.amber[950],
        background: theme.palette.tailwind.amber[100],
    },
    messageBlocking: {
        color: theme.palette.tailwind.red[950],
        background: theme.palette.tailwind.red[100],
    },
}))

// "info": the order can go through, this only tells the user what to expect.
// "warning": the order can go through, but something about it is off.
// "blocking": no delivery is possible at all, the user has to change something.
export type DeliveryMessageTone = "info" | "warning" | "blocking"

type DeliveryMessageBoxProps = Readonly<{
    tone?: DeliveryMessageTone
    children?: ReactNode
}>

export function DeliveryMessageBox({ tone = "info", children }: DeliveryMessageBoxProps) {
    const { classes, cx } = useStyles()

    const toneClasses: Record<DeliveryMessageTone, string> = {
        info: classes.messageInfo,
        warning: classes.messageWarning,
        blocking: classes.messageBlocking,
    }

    return (
        <Typography variant="body2" className={cx(classes.message, toneClasses[tone])}>
            {children}
        </Typography>
    )
}
